export interface MockCategory {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export const mockCategories: MockCategory[] = [
  {
    id: 'entertainment',
    name: '娱乐热点',
    icon: 'ri-fire-line',
    desc: '演唱会、综艺、明星动态，最具话题性的娱乐讨论都在这里',
    count: 128,
  },
  {
    id: 'society',
    name: '社会民生',
    icon: 'ri-building-2-line',
    desc: '通勤、住房、消费与城市生活，和每个人息息相关的话题',
    count: 96,
  },
  {
    id: 'internet',
    name: '互联网舆情',
    icon: 'ri-signal-tower-line',
    desc: '平台规则、算法变动与网络现象，看懂讨论背后的情绪',
    count: 74,
  },
  {
    id: 'film',
    name: '影视综艺',
    icon: 'ri-movie-2-line',
    desc: '电影、剧集与综艺的口碑争议，观影前后的集中讨论区',
    count: 152,
  },
  {
    id: 'sports',
    name: '体育赛场',
    icon: 'ri-trophy-line',
    desc: '赛事复盘、选手表现与战术分析，理性与激情并存',
    count: 83,
  },
  {
    id: 'tech',
    name: '科技前沿',
    icon: 'ri-cpu-line',
    desc: '新工具实测、产品迭代与行业变化，普通用户的真实反馈',
    count: 61,
  },
];